export const options = [
  {
    logo: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.21094 4.73102L5.04198 8.00388V10.0002L3.21308 13.2667L3.21094 4.73102Z"
          fill="#667085"
        />
        <path
          d="M10.2422 6.8131L11.9579 5.7615L15.4693 5.75822L10.2422 8.9604V6.8131Z"
          fill="#667085"
        />
        <path
          d="M10.2319 4.71186L10.2416 9.04501L8.40625 7.91731V1.44L10.2319 4.71186Z"
          fill="#667085"
        />
        <path
          d="M15.4687 5.75816L11.9572 5.76144L10.2319 4.71186L8.40625 1.44L15.4687 5.75816Z"
          fill="#667085"
        />
        <path
          d="M10.2416 13.285V11.1827L8.40625 10.0764L8.40726 16.5602L10.2416 13.285Z"
          fill="#667085"
        />
        <path
          d="M11.9528 12.2428L5.04185 8.00388L3.21094 4.73102L15.4611 12.2385L11.9528 12.2428Z"
          fill="#667085"
        />
        <path
          d="M8.40625 16.5601L10.2403 13.2849L11.9518 12.2429L15.46 12.2386L8.40625 16.5601Z"
          fill="#667085"
        />
        <path
          d="M3.21484 13.2669L8.42282 10.0765L6.67192 9.00224L5.04374 10.0004L3.21484 13.2669Z"
          fill="#667085"
        />
      </svg>
    ),
    name: 'СБП',
  },
  {
    logo: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.83203 9C1.83203 6.17175 1.83203 4.75725 2.71103 3.879C3.59003 3.00075 5.00378 3 7.83203 3H10.832C13.6603 3 15.0748 3 15.953 3.879C16.8313 4.758 16.832 6.17175 16.832 9C16.832 11.8282 16.832 13.2427 15.953 14.121C15.074 14.9992 13.6603 15 10.832 15H7.83203C5.00378 15 3.58928 15 2.71103 14.121C1.83278 13.242 1.83203 11.8282 1.83203 9Z"
          stroke="#667085"
          strokeWidth="1.5"
        />
        <path
          d="M7.83203 12H4.83203M10.832 12H9.70703M1.83203 7.5H16.832"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
    name: 'Карта',
  },
  {
    logo: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.832 1.5H4.83203C4.43421 1.5 4.05268 1.65804 3.77137 1.93934C3.49007 2.22064 3.33203 2.60218 3.33203 3V15C3.33203 15.3978 3.49007 15.7794 3.77137 16.0607C4.05268 16.342 4.43421 16.5 4.83203 16.5H13.832C14.2299 16.5 14.6114 16.342 14.8927 16.0607C15.174 15.7794 15.332 15.3978 15.332 15V6L10.832 1.5Z"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.832 1.5V6H15.332"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.332 9.75H6.33203"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.332 12.75H6.33203"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.83203 6.75H7.08203H6.33203"
          stroke="#667085"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    name: 'Счет',
  },
]

export const icons = {
  СБП: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.21094 4.73102L5.04198 8.00388V10.0002L3.21308 13.2667L3.21094 4.73102Z"
        fill="#667085"
      />
      <path
        d="M10.2422 6.8131L11.9579 5.7615L15.4693 5.75822L10.2422 8.9604V6.8131Z"
        fill="#667085"
      />
      <path
        d="M10.2319 4.71186L10.2416 9.04501L8.40625 7.91731V1.44L10.2319 4.71186Z"
        fill="#667085"
      />
      <path
        d="M15.4687 5.75816L11.9572 5.76144L10.2319 4.71186L8.40625 1.44L15.4687 5.75816Z"
        fill="#667085"
      />
      <path
        d="M10.2416 13.285V11.1827L8.40625 10.0764L8.40726 16.5602L10.2416 13.285Z"
        fill="#667085"
      />
      <path
        d="M11.9528 12.2428L5.04185 8.00388L3.21094 4.73102L15.4611 12.2385L11.9528 12.2428Z"
        fill="#667085"
      />
      <path
        d="M8.40625 16.5601L10.2403 13.2849L11.9518 12.2429L15.46 12.2386L8.40625 16.5601Z"
        fill="#667085"
      />
      <path
        d="M3.21484 13.2669L8.42282 10.0765L6.67192 9.00224L5.04374 10.0004L3.21484 13.2669Z"
        fill="#667085"
      />
    </svg>
  ),
  Карта: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.83203 9C1.83203 6.17175 1.83203 4.75725 2.71103 3.879C3.59003 3.00075 5.00378 3 7.83203 3H10.832C13.6603 3 15.0748 3 15.953 3.879C16.8313 4.758 16.832 6.17175 16.832 9C16.832 11.8282 16.832 13.2427 15.953 14.121C15.074 14.9992 13.6603 15 10.832 15H7.83203C5.00378 15 3.58928 15 2.71103 14.121C1.83278 13.242 1.83203 11.8282 1.83203 9Z"
        stroke="#667085"
        strokeWidth="1.5"
      />
      <path
        d="M7.83203 12H4.83203M10.832 12H9.70703M1.83203 7.5H16.832"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  Счет: (
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.832 1.5H4.83203C4.43421 1.5 4.05268 1.65804 3.77137 1.93934C3.49007 2.22064 3.33203 2.60218 3.33203 3V15C3.33203 15.3978 3.49007 15.7794 3.77137 16.0607C4.05268 16.342 4.43421 16.5 4.83203 16.5H13.832C14.2299 16.5 14.6114 16.342 14.8927 16.0607C15.174 15.7794 15.332 15.3978 15.332 15V6L10.832 1.5Z"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.832 1.5V6H15.332"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.332 9.75H6.33203"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.332 12.75H6.33203"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.83203 6.75H7.08203H6.33203"
        stroke="#667085"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}
